import React from 'react';

const SvgComponent = (props) => (
  <svg
    data-name="device tablet-layer"
    viewBox="0 0 18 18"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M14.52 0h-11a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm.8 16a.81.81 0 0 1-.8.8h-11a.81.81 0 0 1-.8-.8V2a.81.81 0 0 1 .8-.8h11a.81.81 0 0 1 .8.8z" />
    <path d="M2.53 2.8h13.11V4H2.53z" />
    <circle cx={8.99} cy={15.32} r={0.78} />
    <path d="M2.3 12.75h13.34v1.2H2.3z" />
  </svg>
);

export default SvgComponent;
